export const languageSwitcher = () => {
  const languageSwitcher = document.querySelector('.js-languageSwitcher')

  if (!languageSwitcher) {
    return
  }

  const languageSwitcherTrigger = languageSwitcher.querySelector('.js-languageSwitcher-trigger') as HTMLElement
  const languageSwitcherContent = languageSwitcher.querySelector('.js-languageSwitcher-content')

  languageSwitcherTrigger.addEventListener('click', () => {
    languageSwitcher.classList.toggle('-active')
  })
}
